
import { VatService } from "@/services/vat-service";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
export default Vue.extend({
	data(){
		let items = VatService.getVatRegimes();
		if (this.purchase){
			items = VatService.getPurchaseVatRegimes();
		}
		return {
			items
		};
	},
	props: {
		value: {
			type: Array as ()=>number[],
			required: true
		},
		purchase: Boolean
	},
	computed: {
		title():TranslateResult{
			if (this.purchase) {
				return this.$ct("purchase-vat-regime-order");
			}
			return this.$ct("vat-regime-order");
		}
	},
	methods: {
		onSorted(){
			this.$emit("input", this.items.map(i=>i.getId()));
		}
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
